module.exports = __webpack_public_path__ + "img/40_38_027_450.652cf1a0.jpg";